<template>
  <div>

    <!-- Mobile content -->
    <div class="content-mobile">
      <MenuMobile ref="mobileMenu"/>
    </div>

    <!-- Desktop content -->
    <div class="content-desktop">
      <NavigationBar @toggle-mobile-menu="toggleMobileMenu"/>
      <router-view></router-view>
    </div>

    <!-- Shared content -->
    <SocialMedia/>

    <!-- Messenger -->
<!--    <Messenger/>-->
  </div>
</template>

<script>
import NavigationBar from "@/components/partials/header/v2/NavigationBar";
import SocialMedia from "@/components/partials/home/SocialMedia";
import MenuMobile from "@/components/partials/menu/MenuMobile";
// import Messenger from "@/components/partials/contact/Messenger";

export default {
  name: "Layout",
  components: {
    // Messenger,
    MenuMobile,
    SocialMedia,
    NavigationBar,
  },
  data: () => ({}),
  methods: {
    toggleMobileMenu: function () {
      this.$refs.mobileMenu.toggleMenu();
    }
  }
}
</script>

<style lang="scss">
@import "../assets/css/base.mixins";
@import "../assets/css/base.variables";

.page-wrapper {
}

.content-desktop {
  margin-top: 40px;
}

@media screen and (min-width: $screen-lg) {
}

</style>
